<template>
	<div class="col-12 col-sm-6 col-md-4 col-lg-3 categoryItem">
		<router-link :to="linkTo" class="inner">
			<img src="@/assets/img/Specials.jpg" alt="specials" v-if="isSpecials"/>
			<img :src="imageUrl(item.images, 'small')" :alt="item.category" v-else />
			<div class="name">{{item.category}}</div>
		</router-link>
	</div>
</template>

<script>
import {imageUrl} from "@/utils";

export default {
	name: "categoryItem",
	components: {},
	props: ["item"],
	methods:{
		imageUrl
	},
	computed: {
		linkTo() {
			let catId = this.$route.params.category;
			let subcatId = this.$route.params.subcategory;

			if (this.isSpecials && !catId) {
				return {
					name: "specials"
				}
			}

			if (!catId) {
				//base level category
				return { name: "category", params: { category: this.item.id } };
			} else if (catId && !subcatId) {
				//subcategory level, check for children and link to listing if none
				return {
				name: "subcategory",
				params: { category: catId, subcategory: this.item.id }
				};
			}
			throw Error("Error with Link To");
		},
		isSpecials() {
			return this.item.category.toLowerCase() == "specials";
		}
	}
};
</script>

<style lang="scss">

@include media-breakpoint-down(sm) {
	.categoryItem a{
		img{
		//   display:none;
			border-radius: $imageRounding;
			width: 80%;
			margin: 0 auto;
			padding:10px;
			display: block;
		}
		color:black;
		// border-bottom: 1px solid #ccc;
		display:block;
		padding: 5px 5%;

		.name{
			display: flex;
			font-weight:bold;
			justify-content: center;
			margin-bottom: 20px;

		//   &:after{
		//     content:"▷";
		//     display:inline-block;
		//   }
		}

	}
}

@include media-breakpoint-up(md) {
	.categoryItem {
		margin: $grid-gutter-width 0;
	}
	.categoryItem .inner {
		position: relative;
		display: block;

		&:hover .name{
			text-decoration: underline;
			color: $CTred;
		}

		.name {
			font-weight:bold;
			color: black;
			position: absolute;
			left: 0;
			right: 0;
			padding: 2%;
			text-align: center;
		}
		img {
		// TODO make images smaller
			border-radius: $imageRounding;
			width: 100%;
			padding:10px;
			display: block;
		}
	}
}
</style>
